var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.725,
    height: 16.746,
    viewBox: "0 0 16.725 16.746",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow_right",
    "data-name": "Arrow right",
    d: "M19.128,10.75A8.374,8.374,0,1,0,25.243,13.4a8.452,8.452,0,0,0-6.115-2.653Zm4.017,8.821-2.283,2.338a.64.64,0,0,1-.916-.894l1.152-1.18H15.64a.711.711,0,1,1,0-1.422h5.431L19.9,17.239a.64.64,0,0,1,.905-.905l2.338,2.338a.64.64,0,0,1,.005.9Z",
    transform: "translate(-10.755 -10.75)",
    fill: "#1492e6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoto);
export default __webpack_public_path__ + "static/media/goto.bcbfe8c3b6a5401262d47adeb4b2bbbd.svg";
export { ForwardRef as ReactComponent };